import type { IHttpClientService } from "@/shared/services/http_client/interfaces/IHttpClientService.ts";
import type { IInstitutionRepository } from "@/app/institution/interfaces/IInstitutionRepository";
import {
  InstitutionDetailsModel,
  InstitutionModel,
  InstitutionsPaginatedModel,
} from "@/app/institution/models/InstitutionModel";
import { InstitutionFilterModel } from "../models/InstitutionFilterModel";

export class InstitutionRepository implements IInstitutionRepository {
  private readonly BASE_URL: string = "/institutions";

  constructor(private readonly httpClientService: IHttpClientService) {}

  async getAllPaginatedInstitutions(
    filter: InstitutionFilterModel,
  ): Promise<InstitutionsPaginatedModel> {
    return await this.httpClientService.get(
      `${this.BASE_URL}/pageable?name=${filter.name}&size=${filter.size}&page=${filter.page}&acronym=${filter.acronym}`,
    );
  }

  async getAllInstitutions(): Promise<InstitutionModel[]> {
    return await this.httpClientService.get(`${this.BASE_URL}`);
  }

  async getDetailsInstitutionById(id: string | number): Promise<InstitutionDetailsModel> {
    return await this.httpClientService.get(`${this.BASE_URL}/${id}/details`);
  }

  async createInstitution(institutionModel: InstitutionModel): Promise<InstitutionModel> {
    return await this.httpClientService.post(`${this.BASE_URL}`, institutionModel);
  }

  async updateInstitution(
    id: string | number,
    institutionModel: InstitutionModel,
  ): Promise<InstitutionModel> {
    return await this.httpClientService.put(`${this.BASE_URL}/${id}`, institutionModel);
  }

  async deleteInstitution(id: string | number): Promise<void> {
    return await this.httpClientService.delete(`${this.BASE_URL}/${id}`);
  }
}
